const api = window.location.host.indexOf('localhost:') === 0 ? 'https://blonie.devsafi.pl/' : (window.location.origin + '/');
// const api = 'https://pppblonie.pl/';
// cons api = 'http://lukstar/blonie/public/';

export default api
